import { render, staticRenderFns } from "./addlibrary.vue?vue&type=template&id=5247e0a9&scoped=true"
import script from "./addlibrary.vue?vue&type=script&lang=js"
export * from "./addlibrary.vue?vue&type=script&lang=js"
import style0 from "./addlibrary.vue?vue&type=style&index=0&id=5247e0a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5247e0a9",
  null
  
)

export default component.exports